var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g, _path17, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 35,
    viewBox: "0 0 116 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 2.23858 2.23858 0 5 0H110.2C112.961 0 115.2 2.23858 115.2 5V29.1333C115.2 31.8948 112.961 34.1333 110.2 34.1333H5C2.23858 34.1333 0 31.8948 0 29.1333V5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1437 18.561C56.1366 18.561 54.5008 20.0876 54.5008 22.1902C54.5008 24.28 56.1366 25.8194 58.1437 25.8194C60.1515 25.8194 61.7874 24.28 61.7874 22.1902C61.7865 20.0876 60.1507 18.561 58.1437 18.561ZM58.1437 24.3909C57.0437 24.3909 56.0956 23.4838 56.0956 22.191C56.0956 20.8846 57.0446 19.9911 58.1437 19.9911C59.2436 19.9911 60.1917 20.8846 60.1917 22.191C60.1917 23.483 59.2436 24.3909 58.1437 24.3909ZM50.1957 18.561C48.1887 18.561 46.5528 20.0876 46.5528 22.1902C46.5528 24.28 48.1887 25.8194 50.1957 25.8194C52.2036 25.8194 53.8394 24.28 53.8394 22.1902C53.8394 20.0876 52.2036 18.561 50.1957 18.561ZM50.1957 24.3909C49.0958 24.3909 48.1477 23.4838 48.1477 22.191C48.1477 20.8846 49.0966 19.9911 50.1957 19.9911C51.2956 19.9911 52.2437 20.8846 52.2437 22.191C52.2446 23.483 51.2956 24.3909 50.1957 24.3909ZM40.7425 19.6754V21.2148H44.4272C44.3171 22.081 44.0287 22.7133 43.5883 23.1527C43.0524 23.6886 42.2136 24.28 40.7425 24.28C38.4743 24.28 36.7011 22.4513 36.7011 20.1831C36.7011 17.915 38.4743 16.0863 40.7425 16.0863C41.9662 16.0863 42.8596 16.5676 43.5192 17.1862L44.6055 16.0999C43.6839 15.2202 42.4611 14.5469 40.7425 14.5469C37.6355 14.5469 35.0234 17.0762 35.0234 20.1831C35.0234 23.2901 37.6355 25.8194 40.7425 25.8194C42.4193 25.8194 43.6848 25.269 44.6738 24.2382C45.691 23.221 46.0075 21.7908 46.0075 20.6363C46.0075 20.2796 45.9802 19.9493 45.9248 19.6746H40.7425V19.6754ZM79.4053 20.8709C79.1032 20.0603 78.1816 18.561 76.2983 18.561C74.4287 18.561 72.8747 20.0321 72.8747 22.1902C72.8747 24.2245 74.415 25.8194 76.4767 25.8194C78.1398 25.8194 79.1024 24.8022 79.5017 24.2109L78.2644 23.3857C77.8522 23.9907 77.2882 24.3892 76.4767 24.3892C75.666 24.3892 75.0883 24.018 74.7171 23.2893L79.57 21.2822L79.4053 20.8709ZM74.456 22.081C74.415 20.6781 75.5423 19.9638 76.3538 19.9638C76.9861 19.9638 77.522 20.2804 77.7012 20.7335L74.456 22.081ZM70.511 25.6001H72.105V14.9326H70.511V25.6001ZM67.8981 19.3725H67.8435C67.4859 18.9458 66.7982 18.561 65.9329 18.561C64.1178 18.561 62.4547 20.1558 62.4547 22.2047C62.4547 24.239 64.1178 25.8203 65.9329 25.8203C66.799 25.8203 67.4859 25.4354 67.8435 24.9959H67.8981V25.5182C67.8981 26.9066 67.1557 27.649 65.9602 27.649C64.984 27.649 64.379 26.9484 64.1315 26.357L62.7431 26.9347C63.1416 27.8964 64.1998 29.0791 65.9602 29.0791C67.8298 29.0791 69.4111 27.9792 69.4111 25.298V18.782H67.899V19.3725H67.8981ZM66.0703 24.3909C64.9703 24.3909 64.0496 23.4693 64.0496 22.2047C64.0496 20.9255 64.9703 19.9911 66.0703 19.9911C67.1557 19.9911 68.0082 20.9255 68.0082 22.2047C68.0082 23.4693 67.1557 24.3909 66.0703 24.3909ZM86.8754 14.9326H83.0601V25.6001H84.6516V21.5587H86.8745C88.6392 21.5587 90.3749 20.2813 90.3749 18.2461C90.3749 16.2109 88.6401 14.9326 86.8754 14.9326ZM86.9163 20.0739H84.6516V16.4174H86.9163C88.1067 16.4174 88.7826 17.403 88.7826 18.2461C88.7826 19.0721 88.1067 20.0739 86.9163 20.0739ZM96.757 18.5422C95.6041 18.5422 94.4103 19.0499 93.9162 20.1755L95.3293 20.7651C95.6314 20.1755 96.1946 19.9826 96.7843 19.9826C97.6077 19.9826 98.4449 20.4767 98.4585 21.3548V21.4648C98.1701 21.3002 97.5523 21.0535 96.7979 21.0535C95.2747 21.0535 93.7234 21.8907 93.7234 23.4548C93.7234 24.8824 94.9727 25.8015 96.3721 25.8015C97.4422 25.8015 98.0327 25.3211 98.4031 24.7579H98.4577V25.5813H99.9954V21.4913C99.9962 19.5986 98.5814 18.5422 96.757 18.5422ZM96.5641 24.3884C96.0436 24.3884 95.3157 24.1272 95.3157 23.4821C95.3157 22.6587 96.2219 22.3429 97.0044 22.3429C97.7033 22.3429 98.0336 22.494 98.4585 22.6996C98.3348 23.6886 97.484 24.3884 96.5641 24.3884ZM105.595 18.7751L103.77 23.4002H103.715L101.821 18.7751H100.105L102.946 25.2391L101.327 28.8351H102.987L107.366 18.7751H105.595ZM91.2538 25.6001H92.8453V14.9326H91.2538V25.6001Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4634 8.74067C40.4634 9.45577 40.2518 10.0249 39.8277 10.4499C39.3464 10.9551 38.7184 11.2077 37.9469 11.2077C37.208 11.2077 36.5791 10.9517 36.0628 10.4397C35.5457 9.92681 35.2871 9.29193 35.2871 8.53417C35.2871 7.77555 35.5457 7.14067 36.0628 6.62867C36.5791 6.11582 37.208 5.85982 37.9469 5.85982C38.3139 5.85982 38.6646 5.9315 38.9974 6.07401C39.3311 6.21737 39.5981 6.40766 39.7978 6.64574L39.3481 7.0963C39.0093 6.69097 38.5426 6.48873 37.9461 6.48873C37.4068 6.48873 36.9409 6.67817 36.5475 7.05705C36.1541 7.43593 35.9578 7.9283 35.9578 8.53331C35.9578 9.13833 36.1541 9.6307 36.5475 10.0096C36.9409 10.3885 37.4068 10.5779 37.9461 10.5779C38.5178 10.5779 38.9948 10.3876 39.3763 10.0062C39.6237 9.75785 39.7671 9.41225 39.8055 8.96937H37.9461V8.35412H40.4267C40.4523 8.48809 40.4634 8.61694 40.4634 8.74067Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3974 6.60227H42.0661V8.22531H44.1687V8.84056H42.0661V10.4636H44.3974V11.0934H41.4082V5.97336H44.3974V6.60227Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1715 11.0934H46.5135V6.60227H45.0834V5.97336H48.6017V6.60227H47.1715V11.0934Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1471 11.0934V5.97336H51.805V11.0934H51.1471Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7227 11.0934H54.0648V6.60227H52.6346V5.97336H56.1529V6.60227H54.7227V11.0934Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.813 10.432C62.3095 10.9491 61.684 11.2077 60.9356 11.2077C60.1873 11.2077 59.5618 10.9491 59.0592 10.432C58.5557 9.9149 58.3048 9.28173 58.3048 8.53335C58.3048 7.78498 58.5557 7.15181 59.0592 6.63469C59.5618 6.11757 60.1873 5.85815 60.9356 5.85815C61.6797 5.85815 62.3044 6.11842 62.8096 6.6381C63.3147 7.15778 63.5673 7.78925 63.5673 8.53335C63.5673 9.28173 63.3156 9.9149 62.813 10.432ZM59.5447 10.0028C59.9236 10.3868 60.3869 10.5779 60.9356 10.5779C61.4843 10.5779 61.9485 10.3859 62.3266 10.0028C62.7055 9.61879 62.8958 9.12898 62.8958 8.53335C62.8958 7.93773 62.7055 7.44791 62.3266 7.06391C61.9485 6.67991 61.4843 6.48877 60.9356 6.48877C60.3869 6.48877 59.9236 6.68077 59.5447 7.06391C59.1667 7.44791 58.9764 7.93773 58.9764 8.53335C58.9764 9.12898 59.1667 9.61879 59.5447 10.0028Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4906 11.0934V5.97336H65.2911L67.7794 9.95587H67.8076L67.7794 8.96942V5.97336H68.4373V11.0934H67.7504L65.1469 6.91715H65.1187L65.1469 7.9036V11.0934H64.4906Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4634 8.74067C40.4634 9.45577 40.2518 10.0249 39.8277 10.4499C39.3464 10.9551 38.7184 11.2077 37.9469 11.2077C37.208 11.2077 36.5791 10.9517 36.0628 10.4397C35.5457 9.92681 35.2871 9.29193 35.2871 8.53417C35.2871 7.77555 35.5457 7.14067 36.0628 6.62867C36.5791 6.11582 37.208 5.85982 37.9469 5.85982C38.3139 5.85982 38.6646 5.9315 38.9974 6.07401C39.3311 6.21737 39.5981 6.40766 39.7978 6.64574L39.3481 7.0963C39.0093 6.69097 38.5426 6.48873 37.9461 6.48873C37.4068 6.48873 36.9409 6.67817 36.5475 7.05705C36.1541 7.43593 35.9578 7.9283 35.9578 8.53331C35.9578 9.13833 36.1541 9.6307 36.5475 10.0096C36.9409 10.3885 37.4068 10.5779 37.9461 10.5779C38.5178 10.5779 38.9948 10.3876 39.3763 10.0062C39.6237 9.75785 39.7671 9.41225 39.8055 8.96937H37.9461V8.35412H40.4267C40.4523 8.48809 40.4634 8.61694 40.4634 8.74067Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3974 6.60227H42.0661V8.22531H44.1687V8.84056H42.0661V10.4636H44.3974V11.0934H41.4082V5.97336H44.3974V6.60227Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1715 11.0934H46.5135V6.60227H45.0834V5.97336H48.6017V6.60227H47.1715V11.0934Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1471 11.0934V5.97336H51.805V11.0934H51.1471Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7227 11.0934H54.0648V6.60227H52.6346V5.97336H56.1529V6.60227H54.7227V11.0934Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.813 10.432C62.3095 10.9491 61.684 11.2077 60.9356 11.2077C60.1873 11.2077 59.5618 10.9491 59.0592 10.432C58.5557 9.9149 58.3048 9.28173 58.3048 8.53335C58.3048 7.78498 58.5557 7.15181 59.0592 6.63469C59.5618 6.11757 60.1873 5.85815 60.9356 5.85815C61.6797 5.85815 62.3044 6.11842 62.8096 6.6381C63.3147 7.15778 63.5673 7.78925 63.5673 8.53335C63.5673 9.28173 63.3156 9.9149 62.813 10.432ZM59.5447 10.0028C59.9236 10.3868 60.3869 10.5779 60.9356 10.5779C61.4843 10.5779 61.9485 10.3859 62.3266 10.0028C62.7055 9.61879 62.8958 9.12898 62.8958 8.53335C62.8958 7.93773 62.7055 7.44791 62.3266 7.06391C61.9485 6.67991 61.4843 6.48877 60.9356 6.48877C60.3869 6.48877 59.9236 6.68077 59.5447 7.06391C59.1667 7.44791 58.9764 7.93773 58.9764 8.53335C58.9764 9.12898 59.1667 9.61879 59.5447 10.0028Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4906 11.0934V5.97336H65.2911L67.7794 9.95587H67.8076L67.7794 8.96942V5.97336H68.4373V11.0934H67.7504L65.1469 6.91715H65.1187L65.1469 7.9036V11.0934H64.4906Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_31_5129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.90486 6.43241C8.65654 6.69524 8.50977 7.10313 8.50977 7.63134V26.5037C8.50977 27.0327 8.65654 27.4398 8.90486 27.7026L8.96801 27.764L19.54 17.1921V17.0675V16.9429L8.96801 6.37012L8.90486 6.43241Z",
    fill: "url(#paint0_linear_31_5129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0625 20.7173L19.5391 17.1921V17.0676V16.943L23.0633 13.4187L23.1427 13.4639L27.318 15.8362C28.5102 16.5137 28.5102 17.6222 27.318 18.3006L23.1427 20.6729L23.0625 20.7173Z",
    fill: "url(#paint1_linear_31_5129)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_31_5129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.143 20.6719L19.5385 17.0674L8.9043 27.7025C9.29683 28.1189 9.94622 28.1701 10.6775 27.7554L23.143 20.6719Z",
    fill: "url(#paint2_linear_31_5129)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.143 13.463L10.6775 6.38029C9.94622 5.96472 9.29683 6.01677 8.9043 6.4332L19.5394 17.0683L23.143 13.463Z",
    fill: "url(#paint3_linear_31_5129)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5 1H110.2V-1H5V1ZM114.2 5V29.1333H116.2V5H114.2ZM110.2 33.1333H5V35.1333H110.2V33.1333ZM1 29.1333V5H-1V29.1333H1ZM5 33.1333C2.79086 33.1333 1 31.3425 1 29.1333H-1C-1 32.447 1.68629 35.1333 5 35.1333V33.1333ZM114.2 29.1333C114.2 31.3425 112.409 33.1333 110.2 33.1333V35.1333C113.514 35.1333 116.2 32.447 116.2 29.1333H114.2ZM110.2 1C112.409 1 114.2 2.79086 114.2 5H116.2C116.2 1.68629 113.514 -1 110.2 -1V1ZM5 -1C1.68629 -1 -1 1.6863 -1 5H1C1 2.79086 2.79086 1 5 1V-1Z",
    fill: "#A6A6A6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_31_5129",
    x: 8.50977,
    y: 6.09351,
    width: 19.7031,
    height: 21.9482,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_31_5129"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_31_5129",
    result: "effect2_innerShadow_31_5129"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_31_5129",
    x: 8.9043,
    y: 17.0674,
    width: 14.2383,
    height: 10.9744,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_31_5129"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31_5129",
    x1: 18.6028,
    y1: 7.43166,
    x2: 4.28218,
    y2: 21.7523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_31_5129",
    x1: 28.8698,
    y1: 17.0676,
    x2: 8.22267,
    y2: 17.0676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_31_5129",
    x1: 21.1856,
    y1: 19.0248,
    x2: 1.76498,
    y2: 38.4454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_31_5129",
    x1: 6.22602,
    y1: 0.150787,
    x2: 14.8979,
    y2: 8.82262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play-store.11ee4d59f735793c75b5690c6177f55f.svg";
export { ForwardRef as ReactComponent };